import React, { useState, useEffect } from 'react';

interface ResponsiveFontSizes {
    xs?: string;
    sm?: string;
    md?: string;
    lg?: string;
    xl?: string;
    xxl?: string;
}

export const useResponsiveText = () => {
    const [windowWidth, setWindowWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getCurrentBreakpoint = () => {
        if (windowWidth < 576) return 'xs';
        if (windowWidth < 768) return 'sm';
        if (windowWidth < 992) return 'md';
        if (windowWidth < 1200) return 'lg';
        if (windowWidth < 1600) return 'xl';
        return 'xxl';
    };

    const getResponsiveStyle = (
        baseStyle: React.CSSProperties,
        fontSizes: ResponsiveFontSizes
    ): React.CSSProperties => {
        const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
        const currentBp = getCurrentBreakpoint();
        const currentIndex = breakpoints.indexOf(currentBp);

        const activeFontSize = breakpoints
            .slice(0, currentIndex + 1)
            .reverse()
            .map(bp => fontSizes[bp])
            .find(size => size) || fontSizes.md || '16px';

        return {
            ...baseStyle,
            fontSize: activeFontSize
        };
    };

    return { getResponsiveStyle };
};